/**
 * GoogleButton.js
 * Extension of buttons lib specifically with google
 * standard logo and text. Supports round mode.
 * @author Pankaj Jaiswal
 */
import React from 'react';
import { Link } from "react-router-dom";
import './Buttons.css'
import Button from './Buttons';
import BaseComponent from '../../BaseComponent';

function getButtonClass(severity, extraClass, forceClass) {
    let options = {
        "default": " btn button-transparent-grey button-grey-text-new ",
        "round": "fb-round"
    }
    severity = !severity || !(severity in options)
        ? "default"
        : severity;
    let result = options[severity];
    if (extraClass) {
        result = result + " " + extraClass;
    }
    if (forceClass) {
        result = forceClass;
    }
    return result;
}

class GenericButton extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this.onMouseOver = this.props.onMouseOver ? this.props.onMouseOver : () => { };
    }

    render() {
        return (
            <div type="button" onClick={this.props.onClick} onMouseOver={this.onMouseOver} className={getButtonClass(
                this.props.severity,
                this.props.extraClass,
                this.props.forceClass
            )} name={this.props.name ? this.props.name : ""}
                data-toggle={this.props.toggle ? this.props.toggle : ""}
                data-target={this.props.target ? this.props.target : ""}>
                <div className="row no-gutters">
                    <div className="col">
                        <img alt="google-play"
                            className="button-logo"
                            src={process.env.REACT_APP_ASSET_PATH + "/trademarks/google/logos/transparent/logo_google_g_icon.png"} />
                        <span className="button-text-google">
                            {this.props.message}
                        </span>
                    </div>
                </div>

            </div>
        )
    }
}

class LoggedInButton extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this.onMouseOver = this.props.onMouseOver ? this.props.onMouseOver : () => { };
    }

    render() {
        return (
            <div type="button" onClick={this.props.onClick} onMouseOver={this.onMouseOver} className={getButtonClass(
                this.props.severity,
                this.props.extraClass,
                this.props.forceClass
            )} name={this.props.name ? this.props.name : ""}
                 data-toggle={this.props.toggle ? this.props.toggle : ""}
                 data-target={this.props.target ? this.props.target : ""}>
                <div className="row no-gutters">
                    <div className="col">
                        <img alt="Img" className="button-logo" src={this.props.imgSrc}/>
                        <span className="button-text-google">Continue as {this.props.message}</span>
                        <span>
                            <img alt="google-play"
                                 className="button-logo"
                                 src={process.env.REACT_APP_ASSET_PATH + "/trademarks/google/logos/transparent/logo_google_g_icon.png"}/>
                        </span>
                    </div>
                </div>

            </div>
        )
    }
}

class LinkButton extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {};
        if (!this.props.to) {
            super.fatal("Unable to render Link without a 'to' property");
        }
        this.onClick = this.props.onClick ? this.props.onClick : () => { };
    }

    render() {
        return (
            <Link
                className={getButtonClass(
                    this.props.severity,
                    this.props.extraClass,
                    this.props.forceClass
                )}
                to={this.props.to}
                onClick={this.onClick}
            >
                <div className="row no-gutters">
                    <div className="col">
                        <img alt="google-play" className="button-logo"
                            src={process.env.REACT_APP_ASSET_PATH + "/trademarks/google/logos/transparent/logo_google_g_icon.png"} />
                        <span className="button-text-google">
                            {this.props.message}
                        </span>
                    </div>
                </div>
            </Link>
        )
    }
}

class RoundButton extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div class="button-google-round" onClick={this.props.onClick}>
                <img alt="G" src={process.env.REACT_APP_ASSET_PATH + "/trademarks/google/logos/transparent/logo_google_g_icon.png"} />
                <span>{this.props.message}</span>
            </div>
        )
    }
}

/**
 * Generic button class that can behave as base <a> or
 * a react <Link> component based on passed props.
 * Input schema:
 * @param {String}  type        link|*  renders as a <Link> or <a>
 * @param {String}  severity    default|info|action renders the appropriate button style
 * @param {String} extraClass   *   Space separated classes to apply
 * @param {String} forceClass   *   Space separated classes to override all button.css classes
 * @returns {Button}
 */
class GoogleButton extends Button {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const buttonDetect = (bProps) => {
            if (bProps.type === "link") {
                return <LinkButton {...this.props} {...bProps} />
            } else if (bProps.type === "round") {
                return <RoundButton {...this.props} {...bProps} />
            }  else if (bProps.type === "loggedIn") {
                return <LoggedInButton {...this.props} {...bProps} />
            }

            return <GenericButton {...this.props} {...bProps} />
        }
        return (
            buttonDetect(this.props)
        )
    }
}

export default GoogleButton;